module.exports = __webpack_public_path__ + "static/media/Buzz_Logo_2019_NEW.7b303c84.png";